module.exports = __webpack_public_path__ + "static/img/theback.07a6defb.jpg";